export const initNavigationShare = async ({
  url,
  title,
  text,
}: {
  url: string;
  title: string;
  text?: string;
}) => {
  if (navigator.share) {
    try {
      await navigator.share({
        title,
        text,
        url,
      });
    } catch (error) {
      console.warn("Error sharing:", error);
    }
  } else {
    console.warn("Web Share API is not supported in this browser.");
  }
};

export const initNavigationCopy = async (url: string) => {
  if (navigator.clipboard) {
    try {
      await navigator.clipboard.writeText(url);
    } catch (error) {
      console.warn("Error copying to clipboard:", error);
    }
  } else {
    console.warn("Clipboard API is not supported in this browser.");
  }
};
